import React from "react";
import cx from "classnames";
import styles from "./Main.module.scss";
import { players } from "./players";
import { Card } from "./Card/Card";
import { Wrapper } from "./Wrapper";

// const TRANSPARENT_PLACEHOLDER =
//   "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";

// const PLACEHOLDER =
//   "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";

export const Main: React.FunctionComponent = () => {
  // const [url, setUrl] = useState<string>(TRANSPARENT_PLACEHOLDER);
  // const [loaded, setLoaded] = useState<boolean>(false);
  // const imageRef = useRef<HTMLImageElement>(null);

  // useEffect(() => {
  //   if (!imageRef.current) {
  //     return;
  //   }

  //   imageRef.current.onload = () => {
  //     setTimeout(() => {
  //       setLoaded(true);
  //     }, 400);
  //   };

  //   setUrl(process.env.PUBLIC_URL + "/images/bg_half_2000x622.webp");
  // }, []);

  return (
    <main className={cx(styles.main)}>
      {/* <div style={{}}>
        <div
          style={{
            margin: "100px auto",
            width: "800px",
            border: "1px solid white",
            backgroundColor: "#0B1215",
          }}
        >
          <svg viewBox="0 0 200 100">
            <path d="M0 42 L200 2 L200 58 L0 98 Z" fill="#fff22d" />
          </svg>
          <svg viewBox="0 0 140 200">
            <rect x={0} width={140} y={0} height={200} fill="#1b1b1b" />
            <path d="M0 60 L140 20 L140 60 L0 100 Z" fill="#fff22d" />
          </svg>
        </div>
      </div> */}

      <div
        className={cx(styles.initImage)}
        // style={{
        //   backgroundImage: `url(${
        //     process.env.PUBLIC_URL + "/images/bg_half_2000x622_low.webp"
        //   })`,
        // }}
      >
        <div
          // style={{
          //   backgroundImage: width > 768 ? `url(${bg})` : "none",
          // }}
          className={cx(styles.bgImage)}
          id="players"
        >
          <Wrapper>
            <h2>Players</h2>
            <div className={cx(styles.cards)}>
              {players.map((player) => {
                return <Card key={player.url} player={player} />;
              })}
            </div>
          </Wrapper>
        </div>
      </div>
    </main>
  );
};
